import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { RouterLink, RouterOutlet } from '@angular/router'
import {
  IxApplication,
  IxApplicationHeader,
  IxContent,
  IxMenu,
  IxMenuAbout,
  IxMenuItem,
  IxMenuSettings,
} from '@siemens/ix-angular/standalone'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { map } from 'rxjs'
import { AppVersion } from 'environments/app.version'
import { AboutInfoComponent } from './core/components/about-info/about-info.component'
import { SettingsComponent } from './core/settings/settings.component'
import { UserAuthComponent } from './core/auth/user-auth.component'

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    IxApplication,
    IxApplicationHeader,
    IxMenu,
    IxMenuItem,
    IxMenuAbout,
    IxMenuSettings,
    IxContent,
    TranslatePipe,
    SettingsComponent,
    AboutInfoComponent,
    RouterLink,
    UserAuthComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  translateService = inject(TranslateService)

  readonly applicationName = toSignal(
    this.translateService
      .getStreamOnTranslationChange('APP.NAME')
      .pipe(map((appName) => (AppVersion.flavor === 'PRD' ? appName : `${appName} (${AppVersion.flavor})`))),
    { initialValue: 'APP.NAME' },
  )
}
